import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import CheckBox from '@propertypal/web-ui/src/inputs/Checkbox';
import { Column } from '@propertypal/web-ui/src/layout';
import { SubHeading } from '@propertypal/web-ui/src/typography';
import React, { FunctionComponent } from 'react';
import { PreferenceColumn, PreferenceRow } from './PreferenceInputs.style';

interface Props {
  filters: SearchState['filters'];
  handleFilterChange: UseSearchState['handleFilterChange'];
  isRental: boolean;
  isNewHomes: boolean;
}

const PreferenceInputs: FunctionComponent<Props> = ({ filters, handleFilterChange, isRental, isNewHomes }) => {
  const indoor = [
    <CheckBox
      name="Ensuite"
      label="Ensuite"
      value={(filters.tags && filters.tags.includes('ensuite')) || false}
      onValueChange={handleFilterChange('tags-ensuite')}
      testID="CheckBox-includeEnsuite"
      key="ensuite"
    />,
    // <CheckBox
    //   name="Loft Conversion"
    //   label="Loft Conversion"
    //   value={(filters.tags && filters.tags.includes('loftConversion')) || false}
    //   onValueChange={handleFilterChange('tags-loftConversion')}
    //   testID="CheckBox-includeLoftConversion"
    //   key="loftConversion"
    // />,
    // <CheckBox
    //   name="Open Fireplace"
    //   label="Open Fireplace"
    //   value={(filters.tags && filters.tags.includes('openFireplace')) || false}
    //   onValueChange={handleFilterChange('tags-openFireplace')}
    //   testID="CheckBox-includeOpenFireplace"
    //   key="openFireplace"
    // />,
    // <CheckBox
    //   name="Open Living Space"
    //   label="Open Living Space"
    //   value={(filters.tags && filters.tags.includes('openLivingSpace')) || false}
    //   onValueChange={handleFilterChange('tags-openLivingSpace')}
    //   testID="CheckBox-includeOpenLivingSpace"
    //   key="openLivingSpace"
    // />,
    <CheckBox
      name="Utility Room"
      label="Utility Room"
      value={(filters.tags && filters.tags.includes('utilityRoom')) || false}
      onValueChange={handleFilterChange('tags-utilityRoom')}
      testID="CheckBox-includeUtilityRoom"
      key="utilityRoom"
    />,
    <CheckBox
      name="Downstairs WC"
      label="Downstairs WC"
      value={(filters.tags && filters.tags.includes('downstairsToilet')) || false}
      onValueChange={handleFilterChange('tags-downstairsToilet')}
      testID="CheckBox-includeDownstairsToilet"
      key="downstairsToilet"
    />,
  ];

  const garage = [
    <CheckBox
      name="Garage"
      label="Garage"
      value={filters.garage && !filters.largeGarage}
      onValueChange={handleFilterChange('garage')}
      testID="CheckBox-includeGarage"
      key="garage"
    />,
    <CheckBox
      name="Large Garage"
      label="Large Garage"
      value={filters.largeGarage && !filters.garage}
      onValueChange={handleFilterChange('largeGarage')}
      testID="CheckBox-includeLargeGarage"
      key="largeGarage"
    />,
  ];

  const outdoor = [
    <CheckBox
      name="Garden"
      label="Garden"
      value={(filters.tags && filters.tags.includes('garden')) || false}
      onValueChange={handleFilterChange('tags-garden')}
      testID="CheckBox-includeGarden"
      key="garden"
    />,
    <CheckBox
      name="Patio"
      label="Patio"
      value={(filters.tags && filters.tags.includes('patio')) || false}
      onValueChange={handleFilterChange('tags-patio')}
      testID="CheckBox-includePatio"
      key="patio"
    />,
    // <CheckBox
    //   name="South Facing Garden"
    //   label="South Facing Garden"
    //   value={(filters.tags && filters.tags.includes('southFacingGarden')) || false}
    //   onValueChange={handleFilterChange('tags-southFacingGarden')}
    //   testID="CheckBox-includeSouthFacingGarden"
    //   key="southFacingGarden"
    // />,
    <CheckBox
      name="Select properties with Space for a Horse"
      label="Space for a Horse"
      value={(filters.tags && filters.tags.includes('roomForAHorse')) || false}
      onValueChange={handleFilterChange('tags-roomForAHorse')}
      testID="CheckBox-includeRoomForAHorse"
      key="roomForAHorse"
    />,
  ];

  const parking = [
    <CheckBox
      name="Driveway"
      label="Driveway"
      value={(filters.tags && filters.tags.includes('driveway')) || false}
      onValueChange={handleFilterChange('tags-driveway')}
      testID="CheckBox-includeDriveway"
      key="driveway"
    />,
    <CheckBox
      name="Off Street Parking"
      label="Off Street Parking"
      value={(filters.tags && filters.tags.includes('offStreetParking')) || false}
      onValueChange={handleFilterChange('tags-offStreetParking')}
      testID="CheckBox-includeOffStreetParking"
      key="offStreetParking"
    />,
    // <CheckBox
    //   name="Allocated Parking"
    //   label="Allocated Parking"
    //   value={(filters.tags && filters.tags.includes('allocatedParking')) || false}
    //   onValueChange={handleFilterChange('tags-allocatedParking')}
    //   testID="CheckBox-includeAllocatedParking"
    //   key="allocatedParking"
    // />,
  ];

  const other = [
    <CheckBox
      name="Select properties in a Cul-de-sac"
      label="Cul-de-sac"
      value={(filters.tags && filters.tags.includes('culDeSac')) || false}
      onValueChange={handleFilterChange('tags-culDeSac')}
      testID="CheckBox-includeCulDeSac"
      key="culDeSac"
    />,
    <CheckBox
      name="Select properties with Disabled Access"
      label="Disabled Access"
      value={(filters.tags && filters.tags.includes('disabledAccess')) || false}
      onValueChange={handleFilterChange('tags-disabledAccess')}
      testID="CheckBox-includeDisabledAccess"
      key="disabledAccess"
    />,
    // <CheckBox
    //   name="Select properties with an Eco Home"
    //   label="Eco Home"
    //   value={(filters.tags && filters.tags.includes('ecoHome')) || false}
    //   onValueChange={handleFilterChange('tags-ecoHome')}
    //   testID="CheckBox-includeEcoHome"
    //   key="ecoHome"
    // />,
    <CheckBox
      name="Select properties with Sea Views"
      label="Sea Views"
      value={(filters.tags && filters.tags.includes('seaViews')) || false}
      onValueChange={handleFilterChange('tags-seaViews')}
      testID="CheckBox-includeSeaViews"
      key="seaViews"
    />,
    <CheckBox
      name="Select properties with Solar Panels"
      label="Solar Panels"
      value={(filters.tags && filters.tags.includes('solarPanels')) || false}
      onValueChange={handleFilterChange('tags-solarPanels')}
      testID="CheckBox-includeSolarPanels"
      key="solarPanels"
    />,
    <CheckBox
      name="Swimming Pool"
      label="Swimming Pool"
      value={(filters.tags && filters.tags.includes('swimmingPool')) || false}
      onValueChange={handleFilterChange('tags-swimmingPool')}
      testID="CheckBox-includeSwimmingPool"
      key="swimmingPool"
    />,
    !isRental && (
      <CheckBox
        name="Select Cash Sale Properties"
        label="Cash Sale"
        value={(filters.tags && filters.tags.includes('cashSale')) || false}
        onValueChange={handleFilterChange('tags-cashSale')}
        testID="CheckBox-includeCashSale"
        key="cashSale"
      />
    ),
    <CheckBox
      name="Select properties in a Rural Area"
      label="Rural Area"
      value={(filters.tags && filters.tags.includes('rural')) || false}
      onValueChange={handleFilterChange('tags-rural')}
      testID="CheckBox-rural"
      key="rural"
    />,
    <CheckBox
      name="Select properties with an Annex"
      label="With Annex"
      value={(filters.tags && filters.tags.includes('annex')) || false}
      onValueChange={handleFilterChange('tags-annex')}
      testID="CheckBox-annex"
      key="annex"
    />,
    <CheckBox
      name="Select properties with Underfloor Heating"
      label="Underfloor Heating"
      value={(filters.tags && filters.tags.includes('underfloorHeating')) || false}
      onValueChange={handleFilterChange('tags-underfloorHeating')}
      testID="CheckBox-underfloorHeating"
      key="underfloorHeating"
    />,
  ];

  const condition = [
    !isRental && (
      <CheckBox
        name="Select properties In Need of Modernisation"
        label="In Need of Modernisation"
        value={(filters.tags && filters.tags.includes('refurbishmentOportunity')) || false}
        onValueChange={handleFilterChange('tags-refurbishmentOportunity')}
        testID="CheckBox-includeRefurbishmentOportunity"
        key="refurbishmentOportunity"
      />
    ),
    !isRental && (
      <CheckBox
        name="Select Investment Opportunity properties"
        label="Investment Opportunity"
        value={(filters.tags && filters.tags.includes('investmentPotential')) || false}
        onValueChange={handleFilterChange('tags-investmentPotential')}
        testID="CheckBox-includeInvestmentPotential"
        key="investmentPotential"
      />
    ),
    !isRental && (
      <CheckBox
        name="Select properties that are a Listed Building"
        label="Listed Building"
        value={(filters.tags && filters.tags.includes('listedBuilding')) || false}
        onValueChange={handleFilterChange('tags-listedBuilding')}
        testID="CheckBox-includeListedBuilding"
        key="listedBuilding"
      />
    ),
    <CheckBox
      name="Select properties that are a Recently Refurbished"
      label="Recently Refurbished"
      value={(filters.tags && filters.tags.includes('recentlyRefurbished')) || false}
      onValueChange={handleFilterChange('tags-recentlyRefurbished')}
      testID="CheckBox-includeRecentlyRefurbished"
      key="recentlyRefurbished"
    />,
  ];

  // const exclude = [
  //   <CheckBox
  //     name="Exclude properties that are Non-Mortgageable"
  //     label="Non-Mortgageable"
  //     value={(filters.excludeTags && filters.excludeTags.includes('nonMortgageable')) || false}
  //     onValueChange={handleFilterChange('excludeTags-nonMortgageable')}
  //     testID="CheckBox-excludeNonMortgageable"
  //     key="nonMortgageable"
  //   />,
  //   <CheckBox
  //     name="Exclude Cash Sale properties"
  //     label="Cash Sale"
  //     value={(filters.excludeTags && filters.excludeTags.includes('cashSale')) || false}
  //     onValueChange={handleFilterChange('excludeTags-cashSale')}
  //     testID="CheckBox-excludeCashSale"
  //     key="cashSale"
  //   />,
  //   <CheckBox
  //     name="Exclude Lapsed Planning Permission properties"
  //     label="Lapsed Planning Permission"
  //     value={(filters.excludeTags && filters.excludeTags.includes('lapsedPlanningPermission')) || false}
  //     onValueChange={handleFilterChange('excludeTags-lapsedPlanningPermission')}
  //     testID="CheckBox-excludeLapsedPlanningPermission"
  //     key="lapsedPlanningPermission"
  //   />,
  //   <CheckBox
  //     name="Exclude Building Control Issue properties"
  //     label="Building Control Issue"
  //     value={(filters.excludeTags && filters.excludeTags.includes('buildingControlIssue')) || false}
  //     onValueChange={handleFilterChange('excludeTags-buildingControlIssue')}
  //     testID="CheckBox-excludeBuildingControlIssue"
  //     key="buildingControlIssue"
  //   />,
  //   <CheckBox
  //     name="Exclude Building Work Required properties"
  //     label="Building Work Required"
  //     value={(filters.excludeTags && filters.excludeTags.includes('buildingWorkRequired')) || false}
  //     onValueChange={handleFilterChange('excludeTags-buildingWorkRequired')}
  //     testID="CheckBox-excludeBuildingWorkRequired"
  //     key="buildingWorkRequired"
  //   />,
  //   <CheckBox
  //     name="Exclude Partially Finished properties"
  //     label="Partially Finished"
  //     value={(filters.excludeTags && filters.excludeTags.includes('partiallyFinishedFeature')) || false}
  //     onValueChange={handleFilterChange('excludeTags-partiallyFinishedFeature')}
  //     testID="CheckBox-excludePartiallyFinishedFeature"
  //     key="partiallyFinishedFeature"
  //   />,
  //   <CheckBox
  //     name="Exclude Building Defect properties"
  //     label="Building Defect"
  //     value={(filters.excludeTags && filters.excludeTags.includes('buildingDefect')) || false}
  //     onValueChange={handleFilterChange('excludeTags-buildingDefect')}
  //     testID="CheckBox-excludeBuildingDefect"
  //     key="buildingDefect"
  //   />,
  //   <CheckBox
  //     name="Exclude Non Standard Construction properties"
  //     label="Non Standard Construction"
  //     value={(filters.excludeTags && filters.excludeTags.includes('nonStandardConstruction')) || false}
  //     onValueChange={handleFilterChange('excludeTags-nonStandardConstruction')}
  //     testID="CheckBox-excludeNonStandardConstruction"
  //     key="nonStandardConstruction"
  //   />,
  // ];

  return (
    <Column w="100%">
      <PreferenceColumn>
        <SubHeading fontSize={20} mb={15}>
          Indoor Preferences
        </SubHeading>
        <PreferenceRow>{indoor}</PreferenceRow>
      </PreferenceColumn>
      <PreferenceColumn>
        <SubHeading fontSize={20} mb={15}>
          Garage Preferences
        </SubHeading>
        <PreferenceRow>{garage}</PreferenceRow>
      </PreferenceColumn>
      <PreferenceColumn>
        <SubHeading fontSize={20} mb={15}>
          Outdoor Preferences
        </SubHeading>
        <PreferenceRow>{outdoor}</PreferenceRow>
      </PreferenceColumn>
      <PreferenceColumn>
        <SubHeading fontSize={20} mb={15}>
          Parking Preferences
        </SubHeading>
        <PreferenceRow>{parking}</PreferenceRow>
      </PreferenceColumn>
      <PreferenceColumn>
        <SubHeading fontSize={20} mb={15}>
          Other Preferences
        </SubHeading>
        <PreferenceRow>{other}</PreferenceRow>
      </PreferenceColumn>
      {!isNewHomes && (
        <PreferenceColumn>
          <SubHeading fontSize={20} mb={15}>
            Condition Preferences
          </SubHeading>
          <PreferenceRow>{condition}</PreferenceRow>
        </PreferenceColumn>
      )}
      {/*
        <PreferenceColumn>
          <SubHeading fontSize={20} mb={10}>Exclude</SubHeading>
          <PreferenceRow>{exclude}</PreferenceRow>
        </PreferenceColumn>
      */}
    </Column>
  );
};

export default PreferenceInputs;
